import * as React from 'react';
import { useToggle } from 'react-use';
import { MagicLinkSent } from './magic-link-sent';

interface AuthLayoutProps {
  children: (emailSent: () => void) => React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = (props) => {
  const [emailSent, toggleEmailSent] = useToggle(false);

  return (
    <div className="flex self-center w-full h-full overflow-auto sm:pb-16">
      <div className="container relative flex justify-center items-center">
        {emailSent ? <MagicLinkSent /> : <>{props.children(toggleEmailSent)}</>}
      </div>
    </div>
  );
};
